module.exports = __webpack_public_path__ + "img/大药材.6901a05c.png";